import { pairsStore } from "@/shared/stores/PairsStore";
import { getPairBetPeriods } from "@/types/index";

export const usePairAvailability = () => {
  const availablePairs = pairsStore.pairs.filter(
    (p) =>
      p.isTradingEnabled &&
      (getPairBetPeriods(p).length > 0 ||
        ((p.minDurationSeconds ?? 0) > 0 && (p.maxDurationSeconds ?? 0) > 0)),
  );

  const activePair = pairsStore.activePair;
  // Don't show locked state before pairs are initialized (activePair may come from cache before API loads)
  const isPairLocked = pairsStore.initialized && activePair
    ? !availablePairs.some((p) => p.id === activePair.id)
    : false;

  return { isPairLocked, availablePairs };
};
